// extracted by mini-css-extract-plugin
export default {"postUploader":"Posts_postUploader__ayzPv","post_container":"Posts_post_container__PVGCn","login_pera":"Posts_login_pera__bYCjy"};